import { useEffect, useState } from 'react';
import { AppButton, Icon } from '@core/designsystem';
import './install-hint.css';

const DISMISSED = 'yatwa.install-hint.dismissed';

/** Приложение запущено с домашнего экрана, а не во вкладке Safari. */
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    // Старый способ Apple: до сих пор единственный верный на части версий iOS.
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

const isIos = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  // iPad с iPadOS 13+ представляется макинтошем; отличает его наличие касаний.
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

/**
 * Подсказка «как поставить приложение».
 *
 * iOS **никогда** не показывает баннер установки сам: юрист, открывший ссылку,
 * остаётся во вкладке Safari — без офлайна как следует и без уведомлений, и не узнаёт,
 * что приложение вообще ставится. Поэтому подсказку показываем мы, ровно один раз
 * и только там, где она уместна: не установлено, iOS, не отклонено раньше.
 *
 * Отказ помнится в `localStorage`: это единственное, что здесь можно потерять
 * без последствий.
 */
export function InstallHint() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(DISMISSED) === '1';
    } catch {
      // Приватный режим Safari бросает на любом обращении к хранилищу.
      dismissed = false;
    }

    setShown(!dismissed && isIos() && !isStandalone());
  }, []);

  if (!shown) return null;

  const close = () => {
    try {
      localStorage.setItem(DISMISSED, '1');
    } catch {
      // Не запомнили — покажем ещё раз. Это дешевле, чем упасть на ровном месте.
    }
    setShown(false);
  };

  return (
    <div className="install-hint" role="dialog" aria-label="Установка приложения">
      <p className="install-hint__title">Поставьте Yatwa на экран «Домой»</p>
      <ol className="install-hint__steps">
        <li>
          <Icon name="share" size={20} /> нажмите «Поделиться» внизу Safari
        </li>
        <li>
          <Icon name="add" size={20} /> выберите «На экран «Домой»»
        </li>
        <li>
          <Icon name="check" size={20} /> откройте Yatwa с домашнего экрана
        </li>
      </ol>
      <p className="install-hint__note">
        Так приложение работает без интернета и открывается без адресной строки.
        Во вкладке браузера этого не будет.
      </p>
      <div className="install-hint__buttons">
        <AppButton variant="text" onClick={close}>
          Понятно
        </AppButton>
      </div>
    </div>
  );
}
